import { apiErrorToToast } from "@/lib/utils";
import { getSuggestionsByQuestionId } from "@/requests/questionnaries/suggestions-by-question-id.request";
import { ApiErrorResponse } from "@/types/apis";
import { useMutation } from "@tanstack/react-query";
import { AxiosError } from "axios";

export const useSuggestionsByQuestionIdMutation = () => {
  return useMutation({
    mutationFn: getSuggestionsByQuestionId,
    onError: (error: AxiosError<ApiErrorResponse>) => {
      apiErrorToToast(error);
    },
  });
};
